import {encoder} from "./encodeHelper";

export const Pagination = {

	initSearchedFields(fieldsNames) {
		const result = {};
		for (const fieldName of fieldsNames) {
			result[fieldName] = undefined;
		}
		return result;
	},

	resetSearch(searchedFields) {
		for (const field in searchedFields) {
			searchedFields[field] = undefined;
		}
	},

	buildSearchCriteria(searchedFields, firstFieldGeneric) {

		let firstField = firstFieldGeneric === true;
		let search = firstFieldGeneric ? '' : '';

		for (const field in searchedFields) {
			let fieldValue = searchedFields[field];
			let isEmpty = fieldValue === undefined || fieldValue === '';
			if (!isEmpty) {
				search += field + '::' + encoder.encodeUrlParam(fieldValue) + '$$';
			}
			if (firstField) {
				firstField = false;
			}
		}
		return search;
	},

	buildAuditSearchCriteria(searchedFields) {
    const params = [];

    for (const field in searchedFields) {
        const val = searchedFields[field];
        if (val !== undefined && val !== '') {
            params.push(field + "=" + encoder.encodeUrlParam(val));
        }
    }

    return params.join("&");
}

};
